// extracted by mini-css-extract-plugin
export default {"industryModel":"styles_industryModel__Q5QDG","boxModel":"styles_boxModel__MxzaV","cross":"styles_cross__Ept3h"};